import React from 'react';
import Icon from './Icon';
import { useApp } from '../../context/AppContext';
import { useUnreadCount } from '../../hooks/useNotifications';

const NotificationBell = () => {
  const { setActiveTab } = useApp();
  const { unread } = useUnreadCount();
  const hasUnread = unread > 0;
  const display   = unread > 99 ? '99+' : unread;

  return (
    <button
      onClick={() => setActiveTab('notifications')}
      aria-label={hasUnread ? `${unread} unread notifications` : 'Notifications'}
      className="relative w-9 h-9 rounded-xl bg-surface-700 flex items-center justify-center text-surface-200 hover:text-slate-800 hover:bg-surface-500 transition-colors press-scale"
    >
      <Icon name="bell" size={17} />
      {hasUnread && (
        <span
          className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-rose-500 text-white text-[10px] font-dm font-bold flex items-center justify-center border-2 border-surface-800 animate-ringPulse"
        >
          {display}
        </span>
      )}
    </button>
  );
};

export default NotificationBell;
